module.exports = __webpack_public_path__ + "static/scrape-7e4302c42811bd4612a2ee2e1f7e8846.jpg";